/**
 * @generated SignedSource<<2af211105f6fccbf5e567c13924a0e2f>>
 * @relayHash 1d9e1b43849e3df74cbece7106034480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a458ec6be112cd3ededf79466ea5c9786377fac3a29e8eb8df551b7938512f4

import type { ConcreteRequest } from 'relay-runtime';
export type ContentRepresentation = "ATLAS_DOC_FORMAT" | "EDITOR" | "EDITOR2" | "EXPORT_VIEW" | "PLAIN" | "RAW" | "STORAGE" | "STYLED_VIEW" | "VIEW" | "WIKI" | "%future added value";
export type Platform = "ANDROID" | "IOS" | "WEB" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type CreateCommentInput = {
  commentBody: CommentBody;
  commentSource?: Platform | null;
  containerId: string;
  parentCommentId?: string | null;
};
export type CommentBody = {
  representationFormat: ContentRepresentation;
  value: string;
};
export type ObjectCommentReplyEditorCreateGeneralReplyMutation$variables = {
  cloudId: string;
  input: CreateCommentInput;
};
export type ObjectCommentReplyEditorCreateGeneralReplyMutation$data = {
  readonly createFooterComment: {
    readonly author: {
      readonly __typename: string;
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly permissionType: SitePermissionType | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    };
    readonly body: {
      readonly value: string;
    };
    readonly contentStatus: string;
    readonly createdAt: {
      readonly value: string;
    };
    readonly createdAtNonLocalized: string;
    readonly id: string;
    readonly links: {
      readonly editui: string | null;
      readonly webui: string | null;
    };
    readonly location: {
      readonly __typename: string;
      readonly commentResolveProperties?: {
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: AGG$Long | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly type: string;
    };
    readonly parentId: string | null;
    readonly permissions: {
      readonly isEditable: boolean;
      readonly isRemovable: boolean;
      readonly isResolvable: boolean;
    };
    readonly version: {
      readonly by: {
        readonly __typename: string;
        readonly displayName: string | null;
      } | null;
      readonly number: number | null;
      readonly when: string | null;
    };
  } | null;
};
export type ObjectCommentReplyEditorCreateGeneralReplyMutation = {
  response: ObjectCommentReplyEditorCreateGeneralReplyMutation$data;
  variables: ObjectCommentReplyEditorCreateGeneralReplyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Comment",
    "kind": "LinkedField",
    "name": "createFooterComment",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "permissionType"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountId"
              }
            ],
            "type": "KnownUser"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "representation",
            "value": "ATLAS_DOC_FORMAT"
          }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
      },
      {
        "kind": "ScalarField",
        "name": "contentStatus"
      },
      {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
      },
      {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "webui"
          },
          {
            "kind": "ScalarField",
            "name": "editui"
          }
        ]
      },
      {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "resolvedTime"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "resolvedFriendlyDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "resolvedUser"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "resolved"
                  }
                ]
              }
            ],
            "type": "FooterComment"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "parentId"
      },
      {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEditable"
          },
          {
            "kind": "ScalarField",
            "name": "isRemovable"
          },
          {
            "kind": "ScalarField",
            "name": "isResolvable"
          }
        ]
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "when"
          },
          {
            "kind": "ScalarField",
            "name": "number"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "1d9e1b43849e3df74cbece7106034480",
    "id": "8a458ec6be112cd3ededf79466ea5c9786377fac3a29e8eb8df551b7938512f4",
    "metadata": {},
    "name": "ObjectCommentReplyEditorCreateGeneralReplyMutation",
    "operationKind": "mutation",
    "text": "mutation ObjectCommentReplyEditorCreateGeneralReplyMutation($cloudId:ID!,$input:CreateCommentInput!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number}}}"
  }
};
})();

(node as any).hash = "bf58f0a383f4e192dfb098a8d5ea1e6c";

export default node;
